import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";
import { Reveal, Stagger, item } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <div>
      <PageHeader
        overline="Services"
        title="Everything you need to win online."
        subtitle="From custom design to hosting and SEO, we handle every detail so your website performs beautifully and converts consistently."
      />
      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.slug}
                variants={item}
                data-testid={`services-page-card-${s.slug}`}
                className="group bg-white border border-black/10 p-8 sm:p-10 hover:border-black transition-colors"
              >
                <Icon size={40} weight="duotone" />
                <h3 className="mt-8 font-display text-2xl font-bold tracking-tight">{s.title}</h3>
                <p className="mt-3 text-zinc-600 leading-relaxed">{s.full}</p>
                <Link to="/contact" className="mt-6 inline-flex items-center gap-2 text-sm font-medium underline underline-offset-4 decoration-zinc-300 group-hover:decoration-black transition-colors">
                  Learn More <ArrowRight size={16} />
                </Link>
              </motion.div>
            );
          })}
        </Stagger>
      </section>

      <section className="bg-black text-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center">
          <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">Not sure what you need?</h2>
          <p className="mt-4 text-zinc-400 max-w-xl mx-auto">Let's talk it through. Book a free, no-pressure consultation and we'll recommend the right path.</p>
          <Link to="/contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-black font-medium px-7 py-4 hover:bg-zinc-200 transition-colors">
            Get a Free Consultation <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
